import { SVGProps } from './types';

const HandWave = (props: SVGProps) => {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="21" height="24" fill="url(#pattern0_5905_12464)" />
      <defs>
        <pattern
          id="pattern0_5905_12464"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use transform="matrix(0.00120785 0 0 0.00109282 -0.105263 -0.0714286)" />
        </pattern>
        <image
          id="image0_5905_12464"
          width="1024"
          height="1024"
          preserveAspectRatio="none"
        />
      </defs>
    </svg>
  );
};

export { HandWave };
